var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-btn',_vm._g({staticClass:"print-btn",attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},on),[_c('v-icon',{attrs:{"small":"","color":hover ? 'green lighten-1' : 'grey'}},[_vm._v("\n          mdi-printer\n        ")])],1)]}}],null,true)})]}}])},[_c('span',[_vm._v("Tiskaj")])])}
var staticRenderFns = []

export { render, staticRenderFns }